import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from 'components/Icon';
import Style from '../../styles/MVPDSSO.module.scss';

const MVPDSSO = ({ sharedTheme, buttonOnClick, rendered, backgroundInline, onClose }) => {
  if (!rendered) return null;

  const {
    signIn_link_header: headerText = 'Link TV Provider',
    signIn_link_text: text = 'To watch live-airing shows, you must first sign in with your TV Provider.',
    signIn_link_button: buttonText = 'Link my TV Provider',
  } = window.Language;

  const innerContainerStyle = backgroundInline && { ...backgroundInline };
  const validButton = buttonOnClick;
  const button = validButton && (
    <button className={Style.signInButton} onClick={buttonOnClick}>
      {buttonText}
    </button>
  );
  const closeButton = onClose && (
    <div className={Style.close} onClick={onClose} aria-label="close">
      <Icon color="white" icon="close" size="large" />
    </div>
  );

  return (
    <div className={classNames(sharedTheme.container, Style.container)}>
      <div className={classNames(Style.innerContainer, Style.signIn)} style={innerContainerStyle}>
        {closeButton}
        <div className={Style.content}>
          <div className={Style.signInHeading}>{headerText}</div>
          <div className={Style.signInSubheading}>{text}</div>
          {button}
        </div>
      </div>
    </div>
  );
};

MVPDSSO.propTypes = {
  sharedTheme: PropTypes.shape({}),
  buttonOnClick: PropTypes.func,
  rendered: PropTypes.bool,
  backgroundInline: PropTypes.shape({}),
  onClose: PropTypes.func,
};

MVPDSSO.defaultProps = {
  sharedTheme: {},
  buttonOnClick: () => {},
  rendered: false,
  backgroundInline: {},
  onClose: null,
};

export default MVPDSSO;
